import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Form, FormikProvider } from 'formik';
import { useTranslation } from 'react-i18next';
import Button from 'components/UI/Buttons/buttons';
import Input from 'components/UI/Input/input';
import Card from 'components/UI/Card';
import { FiAlertCircle } from 'react-icons/fi';
import css from '../styles.module.scss';
import { useForgotPasswordDetail } from '../hooks/useForgotPasswordDetail';

const ForgotPassword: FC = () => {
  const { t } = useTranslation();

  const {
    formikContext,
    values,
    handleChange,
    handleBlur,
    submitCount,
    errors,
    touched,
    confirm,
  } = useForgotPasswordDetail();

  return (
    <>
      <Card noHover className={css.form__card}>
        <FormikProvider value={formikContext}>
          <Form className={css.form__block}>
            <h1 className={css.form__title}>
              {t('login_page.forgotYourPass')}
            </h1>
            {typeof confirm === 'string' && (
              <div className={css.form__confirm}>
                <FiAlertCircle size={24} />
                <span>{confirm}</span>
              </div>
            )}
            <Input
              label={t('form.common.email')}
              error={!!submitCount && !!touched.email && !!errors.email}
              errortext={errors.email}
              inputAttributes={{
                name: 'email',
                value: values.email,
                onChange: handleChange,
                onBlur: handleBlur,
                placeholder: t(`campaigns_page.campaign_settings.Please_enter`),
              }}
            />
            <Button
              title={t('login_page.resetPass')}
              buttonAttributes={{
                type: 'submit',
                className: css.form__submit,
              }}
            />
            <div>Ссылка для восстановления будет направлена вам на почту</div>
          </Form>
        </FormikProvider>
      </Card>
      <div className={css.form__new}>
        <span> {t('form.common.have_acc')} </span>
        <Link to="/auth/sign-in">{t('form.common.signin')}</Link>
      </div>
    </>
  );
};

export default ForgotPassword;
